function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Orion_flame Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "07-desktop-UI",
  transform: "translate(-1068.000000, -219.000000)",
  stroke: "#3F5063",
  strokeWidth: 1.632
}, React.createElement("g", {
  id: "Orion_flame-Copy",
  transform: "translate(1069.253666, 220.000000)"
}, React.createElement("path", {
  d: "M22.6832845,6.4 C18.9567449,9.65333333 19.4428152,14.9333333 19.4428152,14.9333333 C19.4428152,14.9333333 13.9340176,6.66666667 16.202346,0 C13.9880254,4.48 4.32062561,5.65333333 8.64125122,18.1333333 C3.18646139,16.1066667 3.24046921,9.6 3.24046921,9.6 C3.24046921,9.6 0,12.8 0,19.2 C0,26.2692447 5.80323,32 12.9618768,32 C20.1205237,32 25.9237537,26.2692447 25.9237537,19.2 C25.9237537,12.6933333 21.2250733,12.7466667 22.6832845,6.4 Z",
  id: "Shape"
}))));

var SvgFlame = function SvgFlame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "28px",
    height: "34px",
    viewBox: "0 0 28 34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flame.d047d4c1.svg";
export { ForwardRef as ReactComponent };